module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAKlBMVEUAAACBh42Bh42Bh42Bh42Bh42Bh42Bh42Bh42Bh42Bh42Bh42Bh42Bh40QB7GXAAAADXRSTlMA170WDsceGt3MMRDBmDiwVAAAADNJREFUCNdjYGAwWsDAwCyrwMBQeHMDA7tsCANDxlUHBgbdywxA1h0giw0oBpYFqwPrAAAs3wsJxxDHeQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_prev.png
// module id = l9a4
// module chunks = 9